exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".edit_wrap[data-v-4458e7a0]{width:1050px;margin:50px auto;border:1px solid #eee}.edit_wrap .edit_tab[data-v-4458e7a0]{display:inline-block;width:262px;height:46px;text-align:center;line-height:46px;color:#fff;background:#ff6c83}.edit_wrap .active_tab[data-v-4458e7a0]{background:#ff4a7d}.edit_wrap .tip_word[data-v-4458e7a0]{margin-top:20px;width:1048px;height:160px;background:#f9f9f9;padding:10px}.lh20[data-v-4458e7a0]{line-height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"id":"data-v-4458e7a0","scoped":true,"hasInlineConfig":false}!./~/less-loader!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/supplierapply/audit/supplierCommonPages.vue
// module id = 372
// module chunks = 0